import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Share2, Facebook, Link2, Instagram } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const ShareButtons = ({ title, url }) => {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);
  const shareUrl = url || window.location.href;
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title || 'WBLA');
  
  const copyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  
  return (
    <div className="flex items-center gap-2" data-testid="share-buttons">
      <span className="text-xs text-slate-400 mr-1"><Share2 size={14} /></span>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`} target="_blank" rel="noopener noreferrer" className="w-7 h-7 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center hover:bg-blue-200 transition" data-testid="share-facebook"><Facebook size={14} /></a>
      <a href={`https://www.instagram.com/womensbasketleague_gr`} target="_blank" rel="noopener noreferrer" className="w-7 h-7 rounded-full bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#F77737] text-white flex items-center justify-center hover:opacity-80 transition" data-testid="share-instagram"><Instagram size={14} /></a>
      <button onClick={copyLink} className="w-7 h-7 rounded-full bg-slate-100 text-slate-600 flex items-center justify-center hover:bg-slate-200 transition" data-testid="share-copy">
        {copied ? <span className="text-green-600 text-xs">ok</span> : <Link2 size={14} />}
      </button>
    </div>
  );
};

export default ShareButtons;
